/**
 * shadcn Collapsible — expandable/collapsible section, built on Base UI.
 *
 * Uses `@base-ui/react/collapsible` for accessible expand/collapse with
 * keyboard support and ARIA attributes.
 *
 * Usage:
 *   <Collapsible>
 *     <CollapsibleTrigger>Toggle</CollapsibleTrigger>
 *     <CollapsibleContent>Hidden content</CollapsibleContent>
 *   </Collapsible>
 *
 * @see docs/styling.md
 */
'use client';

import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
import { cn } from '@web-app/lib/utils';
import { ComponentPropsWithoutRef } from 'react';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.Trigger;

function CollapsibleContent({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Panel>) {
  return (
    <CollapsiblePrimitive.Panel
      className={cn('overflow-hidden', className)}
      {...props}
    >
      {children}
    </CollapsiblePrimitive.Panel>
  );
}

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
